// Determine environment-specific cache key prefix
const getEnvironmentPrefix = (): string => {
  // First, try to get from environment variable
  if (process.env.NEXT_PUBLIC_ENV) {
    return process.env.NEXT_PUBLIC_ENV;
  }

  // Fallback to hostname detection for client-side
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('staging')) return 'staging';
    if (hostname.includes('localhost') || hostname.includes('dev'))
      return 'dev';
    return 'prod';
  }
  return 'default';
};

export const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_B2C_CLIENT_ID || '',
    authority:
      process.env.NEXT_PUBLIC_B2C_INSTANCE +
      '/' +
      process.env.NEXT_PUBLIC_B2C_POLICY,
    knownAuthorities: [process.env.NEXT_PUBLIC_B2C_INSTANCE || ''],
    redirectUri: process.env.NEXT_PUBLIC_AUTH_REDIRECT_URL || '',
    postLogoutRedirectUri:
      process.env.NEXT_PUBLIC_AUTH_POST_LOGOUT_REDIRECT_URL || '',
    navigateToLoginRequestUrl: true, // If 'true', will navigate back to the original request location before processing the auth code response.
    scopes: ['openid', 'profile', process.env.NEXT_PUBLIC_B2C_SCOPES || ''],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
    // Environment-specific cache key prefix to prevent collision
    cacheKeyPrefix: `msal-${getEnvironmentPrefix()}`,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', process.env.NEXT_PUBLIC_B2C_SCOPES || ''],
};
